export default __webpack_public_path__ + "static/media/job_offer16_l.e30c531a.jpg";